/* ══════════════════════════════════════════════════════════════════════════
 * CLS-DK FAQ data (Danish)
 * Sourced from clothing.clseifert.com/faq + brand-specific copy.
 * Replace with backend-driven content when /api/faq/{brandSlug} ships.
 * ══════════════════════════════════════════════════════════════════════════ */

export const CATEGORIES = [
  { id: 'ordering',  label: 'Bestilling' },
  { id: 'design',    label: 'Design & tryk' },
  { id: 'delivery',  label: 'Levering' },
  { id: 'sizing',    label: 'Størrelser & pasform' },
  { id: 'aftercare', label: 'Vask & pleje' },
];

export const QUESTIONS = [
  {
    id: 'order-before-drawing',
    category: 'ordering',
    popular: true,
    popularRank: 1,
    question: 'Kan vi godt bestille, før vi har indsendt tegning?',
    answer: 'Ja, man kan bestille, inden tegningen er indsendt.',
  },
  {
    id: 'drawing-deadline',
    category: 'design',
    popular: true,
    popularRank: 2,
    question: 'Hvornår skal vi senest have sendt tegning?',
    answer: 'Tegningen bedes uploadet en uge inden betalingsfristen udløber.',
  },
  {
    id: 'modify-order',
    category: 'ordering',
    popular: true,
    popularRank: 3,
    question: 'Kan jeg ændre i min bestilling?',
    answer: 'Du kan redigere i din bestilling via "Rediger ordre" på din ordrebekræftelse.',
  },
  {
    id: 'no-confirmation',
    category: 'ordering',
    popular: true,
    popularRank: 4,
    question: 'Jeg har ikke modtaget ordrebekræftelse på min bestilling?',
    answer: 'Skriv gerne til al@clseifert.dk.',
  },
  {
    id: 'drawing-adjustments',
    category: 'design',
    popular: true,
    popularRank: 5,
    question: 'Retter I tegningen til?',
    answer: 'Tegningen bliver tilpasset.',
  },
  {
    id: 'sizing-help',
    category: 'sizing',
    popular: true,
    popularRank: 6,
    question: 'Hvordan er størrelserne?',
    answer: 'Under hvert produkt finder du en størrelsesguide.',
  },
  {
    id: 'shrinkage',
    category: 'aftercare',
    popular: true,
    popularRank: 7,
    question: 'Krymper tøjet i vask?',
    answer: 'Ja, produkterne er i bomuld, som krymper — regn med ca. 2%.',
  },
  {
    id: 'back-print-uniform',
    category: 'design',
    popular: true,
    popularRank: 8,
    question: 'Skal alle have samme rygtryk?',
    answer: 'Ja, alle trøjer skal have samme rygtryk.',
  },
  {
    id: 'mixed-colors',
    category: 'design',
    popular: true,
    popularRank: 9,
    question: 'Kan alle elever have forskellige farver trøje?',
    answer: 'Man kan blande modeller og farver, som man har lyst.',
  },
  {
    id: 'delivery-time',
    category: 'delivery',
    popular: true,
    popularRank: 10,
    question: 'Hvor længe går der fra vi sender tegningen til vi får trøjerne?',
    answer: 'Når vi har modtaget jeres tegning, modtager I en leveringsdato, som altid er i god tid før jeres afrejse.',
  },
];
